import { gql } from "@apollo/client";

/**
 * QUERIES
 * */

export const GET_PHYSICAL_STORE_WINE_RECOMMENDATIONS = gql`
  query PhysicalStoreWineRecommendations($locationId: Int!, $recommendedWineIds: [Int!], $memberId: Int) {
    physicalStoreWineRecommendations(
      locationId: $locationId
      recommendedWineIds: $recommendedWineIds
      memberId: $memberId
    ) {
      id
      wine {
        id
        year
        product {
          id
          name
          slug
          productPhotos {
            id
            photoSmall
            photoLarge
          }
          coverPhotoSmall
          sellingPrice
        }
        wineRegion {
          id
          name
        }
        wineType {
          id
          name
          wineClass {
            id
            name
          }
        }
      }
      quantity
      isRecommended
      memberLikelihood
      boxSlot
    }
  }
`;

export const REFRESH_PHYSICAL_STORE_RECOMMENDATION = gql`
  mutation RefreshPhysicalStoreRecommendation($input: RefreshPhysicalStoreRecommendationInput!) {
    refreshPhysicalStoreRecommendation(input: $input) {
      errors {
        field
        messages
      }
      physicalStoreWineRecommendation {
        id
        wine {
          id
          year
          product {
            id
            name
            slug
            productPhotos {
              id
              photoSmall
              photoLarge
            }
            coverPhotoSmall
            sellingPrice
          }
          wineRegion {
            id
            name
          }
          wineType {
            id
            name
            wineClass {
              id
              name
            }
          }
          winePriceRange {
            id
          }
        }
        quantity
        isRecommended
        memberLikelihood
        boxSlot
      }
    }
  }
`;
